import { z } from 'my-zod'
import { customerWaiversSystemView } from './customer-waivers-system-view'
import { legacyAdditionalRider } from '../../customer-operations/riders'

export const customerWaiversOutfitterView = customerWaiversSystemView
  .omit({
    hasVehicleUseHistory: true,
    serverLastModifiedDate: true
  })
  .augment({
    isDLPhotoNeeded: z.boolean(),
    reservationId: z.string().uuid().nullable(),

    // new riders/participant interface
    additionalRiders: legacyAdditionalRider.array().optional()
  })

export type customerWaiversOutfitterView = z.infer<typeof customerWaiversOutfitterView>
